import { EditorState } from 'draft-js';
import { useCallback } from 'react';
import { getEditorStateSnapshot, updateEditorStateOnReturn } from '../util';
import { adjustBlockDepthForContentState, isBlockListItem } from '../util/block';

var useHandleReturnCallback = function useHandleReturnCallback(editorState, setEditorState) {
  return useCallback(function (event) {
    var _getEditorStateSnapsh = getEditorStateSnapshot(editorState),
        selection = _getEditorStateSnapsh.selection,
        content = _getEditorStateSnapsh.content,
        block = _getEditorStateSnapsh.block;

    if (isBlockListItem(block) && block.getDepth() > 0 && !block.getText()) {
      var withAdjustment = adjustBlockDepthForContentState(content, selection, -1);
      setEditorState(EditorState.push(editorState, withAdjustment, 'adjust-depth'));
      return 'handled';
    }

    var newState = updateEditorStateOnReturn(editorState, event);

    if (newState) {
      setEditorState(newState);
      return 'handled';
    }

    return 'not-handled';
  }, [editorState, setEditorState]);
};

export default useHandleReturnCallback;